<template>
  <button class="btn border-2 border-indigo-500 text-indigo-500" @click="$emit('click')">{{ text }}</button>
</template>

<script>
export default {
    props: ["text"],
};
</script>

<style lang="scss" scoped></style>
